import { useAppDispatch, useAppSelector } from '@customer/store/hooks';
import {
  register,
  selectGridData,
  setFirstVisibleRow,
  setColumnState,
  setSelectedRows,
} from '@customer/store/slices/gridSlice';
import type { GridController } from '@dmc/ui/tables';

export const useGridController: GridController = ({ sliceKey }) => {
  const dispatch = useAppDispatch();
  const gridState = useAppSelector(state => selectGridData(state, sliceKey));
  const prefs = useAppSelector(state => state.prefs);

  return {
    gridState,
    darkTheme: prefs.darkTheme,
    dispatch,
    setFirstVisibleRow,
    setColumnState,
    setSelectedRows,
    register,
  };
};
